import { Project, Video } from 'api/schema'
import { RootState } from 'utils/interfaces'
import { formatDate } from 'utils/dateUtils'
import { useSelector } from 'react-redux'
import { groupBy } from 'lodash'
import VideosGrouped from './VideosGrouped/VideosGrouped'
import style from './ProjectInfo.module.css'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

enum GroupingType {
  BY_DATE = 'date',
  BY_GROUP = 'group',
}

const ProjectInfo = ({ project }: { project: Project }) => {
  const projectId = useSelector((state: RootState) => state.project.project?.id)
  const groups = useSelector((state: RootState) => state.project.groups)
  const [grouping, setGrouping] = useState<GroupingType>(GroupingType.BY_DATE)
  const { t } = useTranslation()

  const videosGroupedByDates = useSelector((state: RootState) => {
    const videos = state.allVideos.videos.filter(video => video.project_id === project.id)
    const result = groupBy(videos, (video: Video) => formatDate(new Date(video.date || ''), 'dd LLL yyyy'))
    return result
  })

  const videoGroupedByGroups = useSelector((state: RootState) => {
    const videos = state.allVideos.videos.filter(video => video.project_id === project.id)
    const result = groupBy(
      videos.filter(video => !!video.group_id),
      (video: Video) => {
        const group = groups?.find(group => group.id === video.group_id)
        return group?.name || 'Без группы'
      }
    )
    return result
  })

  const videoGrouped = grouping === GroupingType.BY_DATE ? videosGroupedByDates : videoGroupedByGroups

  return (
    <div className={style.projectInfo}>
      <div className={style.groupingSwitcherBlock}>
        {t('projects.group_by')}
        <span
          className={grouping === GroupingType.BY_DATE ? style.active : style.inactive}
          onClick={() => setGrouping(GroupingType.BY_DATE)}
        >
          {t('projects.by_dates')}
        </span>
        <span
          className={grouping === GroupingType.BY_GROUP ? style.active : style.inactive}
          onClick={() => setGrouping(GroupingType.BY_GROUP)}
        >
          {t('projects.by_groups')}
        </span>
      </div>
      {!!Object.keys(videoGrouped).length &&
        Object.keys(videoGrouped).map(name => (
          <VideosGrouped groupName={name} videos={videoGrouped[name]} key={name} projectId={projectId || 0} />
        ))}
      {grouping === GroupingType.BY_GROUP && Object.keys(videoGroupedByGroups).length === 0 && (
        <div className={style.noData}>{t('projects.no_groups')}</div>
      )}
      {grouping === GroupingType.BY_DATE && Object.keys(videosGroupedByDates).length === 0 && (
        <div className={style.noData}>{t('projects.no_videos')}</div>
      )}
    </div>
  )
}

export default ProjectInfo
